import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Stack } from '@eds-web/react';
import styled from '@emotion/styled';

const StyledProfileHeader = styled(Stack)`
    & a {
        text-decoration: underline;
    }
`;

export const ProfileHeader: React.FC = () => {
    const { t } = useTranslation();

    return (
        <StyledProfileHeader gap={16}>
            <Text variant="headingLG">{t('epic.esport.profile.title')}</Text>
            <Text
                variant={'paragraphMD'}
                dangerouslySetInnerHTML={{ __html: t('epic.esport.profile.info') }}
            />
        </StyledProfileHeader>
    );
};
